import * as Cesium from 'cesium';
import BaseLayer from "./baseLayer";
import * as turf from '@turf/turf'
/**
 * 区域图层
 */
class FourColorLayer extends BaseLayer{

    constructor(options={}){
        options.layerName=options.layerName||CONSTANTS.LAYER.AREA;//图层名
        super(options);
    }

    addEntities(data){
        let self=this;
        self.clearLayer();
        data.forEach((obj,index) =>{
            let item={...obj};
            item.layerName=self.layerName;
            let coordinates=[];
            item.coordinate.forEach((points,index1)=>{
              if(points.length>0){
                let positions=[],_coordinates=[];
                points.forEach((point)=>{
                  if(point.length>0){
                    let {lat,lon}=gcj_decrypt(point[1],point[0]);//坐标转换高德->wgs84
                    _coordinates.push([lon,lat]);
                    positions.push(Cesium.Cartesian3.fromDegrees(lon,lat,5));//高度单位：米
                  }
                });
                coordinates.push(_coordinates);
                let polygonEntity = new Cesium.Entity({
                  id: 'POLYGON'+index+index1,
                  name:item.name,
                  polygon: {
                    hierarchy: new Cesium.PolygonHierarchy(positions),
                    material: Cesium.Color.fromCssColorString(self.colors[item.unit]).withAlpha(0.5),
                    classificationType: Cesium.ClassificationType.BOTH,
                  }
                });
                self.dataSource.entities.add(polygonEntity);
              }

            });
            let centroid = turf.getCoord(turf.centroid(turf.polygon(coordinates)));//获取线段中心点
            console.log(item);
            let labelEntity = new Cesium.Entity({
              id:'LABEL'+index,
              name:item.assetName,
              attributes:item,
              position : Cesium.Cartesian3.fromDegrees(centroid[0], centroid[1],CONSTANTS.ALTITUDE+200),//高度单位：米
              //字体标签样式
              label : {
                text : `${item.unit}\n${item.name}`,
                font : 'normal 12px MicroSoft YaHei',
                backgroundColor:Cesium.Color.fromCssColorString(self.colors[item.unit]+'40'),
                fillColor:Cesium.Color.fromCssColorString(self.colors[item.unit]),
                showBackground: true,
                style: Cesium.LabelStyle.FILL_AND_OUTLINE,
                outlineWidth : 1,
                outlineColor:Cesium.Color.WHITE,
                //垂直位置
                verticalOrigin : Cesium.VerticalOrigin.CENTER,
                //中心位置
                pixelOffset : new Cesium.Cartesian2(0, 26)
              }
            });
            self.dataSource.entities.add(labelEntity);
        });
    }
}
export default FourColorLayer;
